// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__P9mc6","link":"Footer_link__XTRoN"};